import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalModule } from 'ngx-bootstrap/modal';
import { NgUploaderModule } from 'shared/ngx-uploader/modules/ngx-uploader.module';

import { SharedModule } from 'shared/shared.module';
import { AppModalModule } from 'shared/modal/modal.module';
import { ReportModalComponent } from './report-modal.component';


@NgModule({
  imports: [
    AppModalModule,
    ModalModule.forRoot(),
    SharedModule,
    NgUploaderModule,
  ],
  declarations: [ReportModalComponent],
  exports: [ReportModalComponent],
  providers: []
})
export class ReportModalModule {}
